import {EnvironmentInterface} from './environment-interface';

export const environment: EnvironmentInterface = {
  backend_url: 'https://api.prsdev.alzp.tgscloud.net',
  authentication: {
    clientId: '56a03f0d-6fc1-4546-beec-037dd2608cc4',
    authority:
      'https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e',
    scopes: ['api://f5bd85df-65b6-4227-90ee-b2c4fae203d4/all'],
    redirectUri: '/',
  },
  featureFlags: {
    changeLang: false,
    showCurrentPortfolio: false,
    editData: false,
  },
  agGridLicenseKey: 'Using_this_{AG_Grid}_Enterprise_key_{AG-082855}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{TotalEnergies_Digital_Factory}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{31_July_2026}____[v3]_[01]_MTc4NTQ1MjQwMDAwMA==a7f0d6d46e63a8b0c82a1b9e58d634b0',
};
